// @lib-generic-ui
import { Typography, Box } from "@mui/material";
import React from "react";

export default function LabelledOutline({ 
  label, 
  children,
  rawBorderColor = "#C4C4C4", 
  rawLabelColor = "#6B6B6B",
}) {

  return (
    <Box
      border={`1px solid ${rawBorderColor}`}
      borderRadius={1}
      position="relative"
      p={3}
      pt={5}
      boxSizing="border-box"
    >
      <Typography
        position="absolute"
        left={2}
        top={0}
        variant="caption"
        px={0.6}
        color={rawLabelColor}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );

}
